/******************************************************
 *                  Environment Ctrl
 ********************************************************/
"use strict";

import dayjs from "dayjs";

angular.module("manager").controller("EnvironmentCtrl", [
	"$scope", "AdminService", "$location", "SecurityService", "CONSTANTS", "toastr", "Utils", "$uibModal", "SharedProperties", "EnvironmentService",
	function ($scope, AdminService, $location, SecurityService, CONSTANTS, toastr, Utils, $uibModal, SharedProperties, EnvironmentService) {

	var modal;

	$scope.data = {
		client: SharedProperties.getAttribute(CONSTANTS.ATT_CLIENT_OBJECT)
	};

	console.log($scope.data.client);

	$scope.duplicateEnvironment = function () {
		$scope.data.newEnvironment = {
			code: $scope.data.client.schemaName + dayjs().format("_DD_MM_YYYY_HH_mm_ss"),
			name: $scope.data.client.name + " - copie du " + dayjs().format("DD/MM/YYYY HH:mm:ss")
		};
		modal = Utils.openModal($uibModal, "duplicate.html", $scope);
	};

	$scope.truncateEnvironment = function () {
		$scope.data.newEnvironment = {
			topology: false
		};
		modal = Utils.openModal($uibModal, "truncate.html", $scope);
	};

	$scope.replaceParent = function () {
		modal = Utils.openModal($uibModal, "replace.html", $scope);
	};


	AdminService.getUserByToken().then((response) => {
		$scope.data.user = response.data;
		$scope.data.isOkinaMember = $scope.data.user.email.indexOf("okina") != -1;
	});

	$scope.startTruncateEnvironment = function () {
		modal.close();
		EnvironmentService.truncateEnvironment($scope.data.client.id, $scope.data.newEnvironment.topology)
			.then(() => {
				toastr.success("", "Environnement vidé");
				toastr.info("", "Vider le cache de votre navigateur internet");
			})
			.catch((error) => {
				toastr.error(Utils.makeErrorMessage(error.data, "Problème lors de l'opération."), "Erreur");
			});
	};

	$scope.deleteEnvironment = function () {
		modal = Utils.openModal($uibModal, "delete.html", $scope);
	};

	$scope.pullSchoolItiEnvironment = function () {
		modal = Utils.openModal($uibModal, "pull.html", $scope);
	};

	$scope.depannageEnvironment = function () {
		modal = Utils.openModal($uibModal, "depannage.html", $scope);
	};

	$scope.prepareAnalyzeSchoolitiEnvironment = function () {
		if($scope.data.user && $scope.data.user.email){
			$scope.data.emailToSendReport = $scope.data.user.email;
		}
		$scope.data.complete = false;
		modal = Utils.openModal($uibModal, "impact.html", $scope);
	};

	$scope.startDeleteEnvironment = function () {
		modal.close();
		EnvironmentService.deleteEnvironment($scope.data.client.id)
			.then(() => {
				toastr.success("", "Environnement supprimé");
				toastr.info("", "Vous allez être déconnecté");
				SecurityService.logout().then(() => {
					$location.path("login");
				}).catch(() => {
					$location.path("login");
				});
			})
			.catch((error) => {
				toastr.error(Utils.makeErrorMessage(error.data, "Problème lors de l'opération."), "Erreur");
			});
	};

	$scope.startReplaceParent = function () {
		modal.close();
		EnvironmentService.replaceEnvironment($scope.data.client.id)
			.then(() => {
				toastr.success("", "Environnement déplacé");
				toastr.info("", "Vous allez être déconnecté");
				SecurityService.logout().then(() => {
					$location.path("login");
				}).catch(() => {
					$location.path("login");
				});
			})
			.catch((error) => {
				toastr.error(Utils.makeErrorMessage(error.data, "Problème lors de l'opération."), "Erreur");
			});
	};

	$scope.startDepannageEnvironment = function () {
		modal.close();
		EnvironmentService.depannageEnvironment($scope.data.client.id)
			.then(() => {
				toastr.success("", "Réseau dépannage créé");
			})
			.catch((error) => {
				toastr.error(Utils.makeErrorMessage(error.data, "Problème lors de l'opération."), "Erreur");
			});
	};

	$scope.startPullSchoolitiEnvironment = function () {
		modal.close();
		EnvironmentService.pullEnvironment($scope.data.client.id)
			.then(() => {
				toastr.success("", "Rapatriement effectué");
			})
			.catch((error) => {
				toastr.error(Utils.makeErrorMessage(error.data, "Problème lors de l'opération."), "Erreur");
			});
	};

	$scope.startAnalyzeSchoolitiEnvironment = function () {
		modal.close();
		EnvironmentService.analyzeImpactEnvironment($scope.data.client.id, $scope.data.emailToSendReport, $scope.data.complete)
			.then(response => {
				toastr.success("", "Analyse terminée");
				var blob = new Blob([response.data], {type: "octet/stream"});
				window.saveAs(blob, "report_impact_" + $scope.data.client.schemaName + ".html");
			})
			.catch((error) => {
				if (error.status === 504) {
					toastr.info("Analyse toujours en cours", "Rapport de conflit");
					return;
				}
				toastr.error(Utils.makeErrorMessage(error.data, "Problème lors de l'opération."), "Erreur");
			});
	};

	$scope.downloadAnalyzeSchoolitiEnvironment = function () {
		EnvironmentService.downloadAnalyzeImpactEnvironment($scope.data.client.id)
			.then((response) => {
				var blob = new Blob([response.data], {type: "octet/stream"});
				window.saveAs(blob, "report_impact_" + $scope.data.client.schemaName + ".html");
			})
			.catch((error) => {
				toastr.error(Utils.makeErrorMessage(error.data, "Problème lors de l'opération."), "Erreur");
			});
	};

	$scope.prepareSchoolItiEnvironment = function () {
		modal = Utils.openModal($uibModal, "prepare.html", $scope);
	};

	$scope.startPrepareEnvironment = function () {
		modal.close();
		EnvironmentService.prepareEnvironment($scope.data.client.id)
			.then(() => {
				toastr.success("", "Environnement préparé");
			})
			.catch((error) => {
				toastr.error(Utils.makeErrorMessage(error.data, "Problème lors de l'opération."), "Erreur");
			});
	};

	$scope.startCopyEnvironment = function () {
		modal.close();
		$scope.data.newEnvironment.code = $scope.data.newEnvironment.code.replace(/ /g, "_");
		EnvironmentService.copyEnvironment($scope.data.client.id, $scope.data.newEnvironment)
			.then(() => {
				toastr.success("", "Environnement copié");
			})
			.catch((error) => {
				toastr.error(Utils.makeErrorMessage(error.data, "Problème lors de l'opération."), "Erreur");
			});
	};

}]
)
;
